/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

const ACTIVE_MENU_ITEM_CLASS = "triMenuItemActive"
const ACTIVE_TOP_PARENT_MENU_ITEM_CLASS = "triMenuItemTopParentActive";
const ACTIVE_MENU_ITEM_BACKGROUND_CLASS = "triMenuItemActiveBackground";
const ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS = "triMenuItemTopParentActiveBackground"
const ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS = "triMenuItemTopParentActiveDescendantBackground"
const ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS = "triMenuItemClosestParentActiveBackground"
const IGNORE_ACTIVE_MENU_ITEM_CLASS_REMOVAL = true;

export class ActiveMenuItemHandler {

    constructor(hierarchyListItemHandler) {
        this.hierarchyListItemHandler = hierarchyListItemHandler;
        this.currentActiveMenuId = null;
        this.currentActiveTopParentMenuId = null
    }

    handle(menuId) {

      
        //Add active to selected menu and top parent
        let menuItem = this.hierarchyListItemHandler.handleValidMenuItem(menuId);
        //If menu item is opening in new window, active menu should stay the same for current page.
        if (menuItem.isOpenInNewWindow) {
          return;
        }

        //First remove menu active classes
        this._removeActiveMenuItemClasses();

        
        var triMenuItemElement;
        var triMenuItemTopParentElement;
        
        this.currentActiveMenuId = menuItem.id;
        triMenuItemElement = document.getElementById(this.currentActiveMenuId);
        if (triMenuItemElement === null) {
            //Reset and return if triMenuItemElement is null
            this.resetCurrentActiveIds(IGNORE_ACTIVE_MENU_ITEM_CLASS_REMOVAL);
            return;
        }
        if (triMenuItemElement.classList.contains("sideNavMenuItemWithChildren")) {
            triMenuItemElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
            triMenuItemElement.parentElement.parentElement.classList.add(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
        } else {
            triMenuItemElement.classList.add(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
        }
        triMenuItemElement.classList.add(ACTIVE_MENU_ITEM_CLASS);
            
        this.currentActiveTopParentMenuId = menuItem.topParentMenuId;
       
        if (this.currentActiveTopParentMenuId != null) {
            triMenuItemTopParentElement = document.getElementById(this.currentActiveTopParentMenuId);
            if (triMenuItemTopParentElement.classList.contains("sideNavMenuItemWithChildren")) {
                triMenuItemTopParentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            }
            triMenuItemTopParentElement.classList.add(ACTIVE_TOP_PARENT_MENU_ITEM_CLASS);
        }

        //Add top level descendant classes
        let topLevelMenuItemId = this.currentActiveTopParentMenuId != null ? this.currentActiveTopParentMenuId: this.currentActiveMenuId;
        let childrenMenuItemIds = this.hierarchyListItemHandler.getChildrenListItemIdsByTopParentId(topLevelMenuItemId);
        //Iterate through each child
        if (childrenMenuItemIds != null) {
            for (var i = 0; i < childrenMenuItemIds.length; i++) {
                let childMenuItemElement = document.getElementById(childrenMenuItemIds[i]);
                if (childMenuItemElement != null) {
                    if (childMenuItemElement.classList.contains("sideNavMenuItemWithChildren")) {
                        childMenuItemElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS);
                    } else {
                        childMenuItemElement.classList.add(ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS);
                    }
                }
            }
        }
        
        //Set the closest parent classes
        let ascendingParentIds = menuItem.ascendingParentIds;
        for (var i = 0; i < ascendingParentIds.length; i++) {
            let closestParentElement = document.getElementById(ascendingParentIds[i]);
            if (closestParentElement != null) {
                closestParentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            }
        } 
    } 

    //First remove menu active classes
    _removeActiveMenuItemClasses() {
        var triMenuItemElement;
        var triMenuItemTopParentElement;
        if (this.currentActiveMenuId != null) {
            triMenuItemElement = document.getElementById(this.currentActiveMenuId);
            if (triMenuItemElement.classList.contains("sideNavMenuItemWithChildren")) {
                triMenuItemElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
                triMenuItemElement.parentElement.parentElement.classList.remove(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
            } else {
                triMenuItemElement.classList.remove(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
            }
            triMenuItemElement.classList.remove(ACTIVE_MENU_ITEM_CLASS);
        }
        if (this.currentActiveTopParentMenuId != null) {
            triMenuItemTopParentElement = document.getElementById(this.currentActiveTopParentMenuId);
            if (triMenuItemTopParentElement.classList.contains("sideNavMenuItemWithChildren")) {
                triMenuItemTopParentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            }
            triMenuItemTopParentElement.classList.remove(ACTIVE_TOP_PARENT_MENU_ITEM_CLASS);
        }

        //Remove top level descendant classes
        if (this.currentActiveMenuId != null || this.currentActiveTopParentMenuId != null) {
            let topLevelMenuItemId = this.currentActiveTopParentMenuId != null ? this.currentActiveTopParentMenuId: this.currentActiveMenuId;
            let childrenMenuItemIds = this.hierarchyListItemHandler.getChildrenListItemIdsByTopParentId(topLevelMenuItemId);
            //Iterate through each child
            if (childrenMenuItemIds != null) {
                for (var i = 0; i < childrenMenuItemIds.length; i++) {
                    let childMenuItemElement = document.getElementById(childrenMenuItemIds[i]);
                    if (childMenuItemElement != null) {
                        childMenuItemElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS);
                        if (childMenuItemElement.classList.contains("sideNavMenuItemWithChildren")) {
                            childMenuItemElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS);
                            childMenuItemElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS);
                        } else {
                            childMenuItemElement.classList.remove(ACTIVE_TOP_PARENT_DESCENDANT_BACKGROUND_CLASS);
                        }
                    }
                }
            }
        }
    }

    resetCurrentActiveIds(ignoreRemoveActiveMenuItemClasses) {
        if (!ignoreRemoveActiveMenuItemClasses) {
            this._removeActiveMenuItemClasses();
        }
        this.currentActiveMenuId = null;
        this.currentActiveTopParentMenuId = null;
    }
}